import { render, staticRenderFns } from "./ExitProductInfo.vue?vue&type=template&id=3aaf10dc&scoped=true"
import script from "./ExitProductInfo.vue?vue&type=script&lang=js"
export * from "./ExitProductInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaf10dc",
  null
  
)

export default component.exports